import React from 'react';
import Onam2023 from 'views/SchoolProgram2023/components/Onam2023';


const SchoolProgrampage = () => {
  return <Onam2023 />;
};

export default SchoolProgrampage;